import { DIGIT_EM_WIDTH, LABEL_MAX_FONT_SIZE, LABEL_MAX_WIDTH, SEPARATOR_EM_WIDTH } from './ProgressCircle.constants';
import type { ProgressCircleRounding } from './ProgressCircle.types';

export type RoundLabelOptions = {
  /** Round to tenths instead of a whole number. */
  showFraction?: boolean;
  /** Rounding mode. */
  rounding?: ProgressCircleRounding;
};

/**
 * Rounds the clamped percentage for the label: to a whole number, or to tenths when `showFraction`
 * is set. Tenths are never padded with a trailing zero, so a whole result stays a whole number.
 */
export const roundLabel = (
  percentage: number,
  { showFraction = false, rounding = 'round' }: RoundLabelOptions = {},
) => {
  const scale = showFraction ? 10 : 1;
  return Math[rounding](percentage * scale) / scale;
};

export type LabelFontSizeOptions = {
  /** One character of the label is a decimal separator, which is narrower than a digit. */
  isFraction?: boolean;
};

/**
 * Shrinks the label font below its 50-unit maximum when the label would otherwise touch the ring.
 * Labels of up to two digits keep the maximum size; the longest possible label, 99.9, still renders
 * at 39 of the 100 viewBox units.
 */
export const labelFontSize = (label: string, { isFraction = false }: LabelFontSizeOptions = {}) => {
  const separatorCount = isFraction ? 1 : 0;
  const emWidth = (label.length - separatorCount) * DIGIT_EM_WIDTH + separatorCount * SEPARATOR_EM_WIDTH;
  return Math.min(LABEL_MAX_FONT_SIZE, LABEL_MAX_WIDTH / emWidth);
};
